import { Card, SxProps, Typography } from "@mui/material";
import Content from "../Layout/Content";
import { useSearchParams } from "react-router";
import { useStatementViewDetails } from "./useStatementViewDetails";
import LoadingOverlay from "../Shared/LoadingOverlay";
import StatementViewItem from "./StatementViewItem";
import { useEffect } from "react";

const statementCardSx: SxProps = { padding: 0 };

function getStatementTitle(statementType?: string | null): string {
    if (statementType === "Superbill") {
        return "Your Superbill";
    }
    return "Your Statement";
}

export default function StatementView() {
    const [searchParams] = useSearchParams();

    const uniqueIdentifier: string | null = searchParams.get("id");

    const { statement, statementLoading } = useStatementViewDetails(uniqueIdentifier);

    const pageTitle = statement ? getStatementTitle(statement.statementType) : "Your Statement";

    useEffect(() => {
        document.title = pageTitle;
    }, [pageTitle]);

    return (
        <Content
            dataTestIdSuffix="view_statement"
            sx={{
                padding: "32px 8px 0",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
            }}
        >
            <Typography variant="heading3">{pageTitle}</Typography>
            {statementLoading ? (
                <LoadingOverlay />
            ) : statement ? (
                <Card variant="outlined" sx={statementCardSx}>
                    <StatementViewItem invoice={statement} />
                </Card>
            ) : null}
        </Content>
    );
}
